import { useEffect, useId } from 'react';
import { create } from 'zustand';
export const useBlockerDialogState = create((set) => ({
    activeBlockers: [],
    addBlocker: (options) => {
        set((state) => ({
            activeBlockers: [...state.activeBlockers, options],
        }));
    },
    removeBlocker: (id) => {
        set((state) => ({
            activeBlockers: state.activeBlockers.filter((blocker) => blocker.id !== id),
        }));
    },
    requestedBlockers: [],
    requestBlocker(options) {
        set((state) => ({
            requestedBlockers: [...state.requestedBlockers, options],
        }));
    },
    clearRequestedBlockers: () => {
        set(() => ({
            requestedBlockers: [],
        }));
    },
}));
export function useBlockBeforeContinue() {
    const hasActiveBlockers = useBlockerDialogState((state) => state.activeBlockers.length > 0);
    const clearRequestedBlockers = useBlockerDialogState((state) => state.clearRequestedBlockers);
    // make sure we clear any blocker requests if we navigate away
    useEffect(() => () => {
        clearRequestedBlockers();
    }, [clearRequestedBlockers]);
    const requestBlocker = useBlockerDialogState((state) => state.requestBlocker);
    // if no blockers, continue immediately
    if (!hasActiveBlockers) {
        return ({ onContinue }) => {
            onContinue();
        };
    }
    return requestBlocker;
}
export function useBlockerDialog(options) {
    const id = useId();
    const addBlocker = useBlockerDialogState((state) => state.addBlocker);
    const removeBlocker = useBlockerDialogState((state) => state.removeBlocker);
    useEffect(() => {
        if (options.disableBlock) {
            return;
        }
        addBlocker({
            disableBlock: options.disableBlock,
            title: options.title,
            content: options.content,
            buttonContinueWithoutSaveText: options.buttonContinueWithoutSaveText,
            onContinueWithoutSave: options.onContinueWithoutSave,
            buttonContinueText: options.buttonContinueText,
            onContinue: options.onContinue,
            id,
        });
        return () => {
            removeBlocker(id);
        };
    }, [
        addBlocker,
        removeBlocker,
        options.disableBlock,
        options.buttonContinueWithoutSaveText,
        options.onContinueWithoutSave,
        options.buttonContinueText,
        options.content,
        options.title,
        options.onContinue,
        id,
    ]);
}
//# sourceMappingURL=use-blocker-dialog.js.map